<template>
  <div class="6c">
    <h3 class="uk-margin-medium-top">6C COLATERAL O GARANTÍAS               </h3>
    <p>Contesta las siguientes preguntas:</p>
    <form id="form" class="uk-text-left">

      <div class="uk-margin">
        <label >a) ¿Este crédito requiere garantía líquida?</label>
        <select class="uk-select" required v-model="data['a - Requiere garantía líquida']" >
          <option value="1">Sí</option>
          <option value="7">No</option>
        </select>
      </div>

      <div class="uk-margin" v-if="data['a - Requiere garantía líquida'] == 1">
        <label >a - 1) Porcentaje del monto solicitado que aporta como garantía líquida</label>
        <select class="uk-select" required v-model="data['b - Cobertura']" >
          <option value="7">Entre 80% o 100%</option>
          <option value="6">Entre 60% y 79.0%  </option>
          <option value="5">Entre 40% 59.9%  </option>
          <option value="4">Entre 20 % y 39%</option>
          <option value="3">Entre 15 y 19% </option>
          <option value="2">Entre 10 y 15% </option>
          <option value="1">Menos del 10%</option>
        </select>      
      </div>



      
      <div class="uk-margin">
        <label >b) ¿Este crédito requiere aval personal?</label>
        <select class="uk-select" required v-model="data['b - Requiere aval personal']" >
          <option value="1">Sí</option>
          <option value="7">No</option>
        </select>
      </div>

      <div class="uk-margin" v-if="data['b - Requiere aval personal'] == 1">
        <label >b - 1) Número de avales que presenta</label>
        <select class="uk-select" required v-model="data['b - Número de avales que presenta']" >
          <option value="5">1</option>
          <option value="6">2</option>
          <option value="7">3</option>
        </select>      
      </div>




      
      <div class="uk-margin">
        <label >c) ¿Este crédito requiere garantía o prenda?</label>
        <select class="uk-select" required v-model="data['c - Requiere garantía o prenda']" >
          <option value="1">Sí</option>
          <option value="7">No</option>
        </select>
      </div>

      <div class="uk-margin" v-if="data['c - Requiere garantía o prenda'] == 1">
        <label >c - 1) Cálculo de la coberta económica de la garantía versus el monto solicitado <br><br></label>
        
        
        <div uk-grid class="uk-child-width-1-2 uk-grid-small">
          <div>
            1) Hipoteca de un bien inmueble
          </div>
          <div>
            <input v-model="cobertura['Casas o deptos']" type="number" step="0.01" placeholder="$ Valor Comercial" class="uk-input">
          </div>
          <div>
            2) Prenda de vehículo
          </div>
          <div>
            <input v-model="cobertura['Terrenos']" type="number" step="0.01" placeholder="$ Valor Comercial" class="uk-input">
          </div>
          <div>
            3) Maquinaria o equipos en prenda
          </div>
          <div>
            <input v-model="cobertura['Vehículos']" type="number" step="0.01" placeholder="$ Valor Comercial" class="uk-input">
          </div>
        </div> 
        <p>Total de garantías: <b>{{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(garantias)}}</b>  
        <br>Monto del crédito: {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(monto)}}
        <br>Cobertura de garantías: <b>% {{cover}}</b>   </p>
      </div>
      


      <div class="uk-margin uk-text-center">
         <button  class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : this.$score['6C COLATERAL O GARANTÍAS'] ? this.$score['6C COLATERAL O GARANTÍAS'] : {},
      cobertura : {},
      monto : this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS'] ? this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Monto solicitado'] : 0.0,
    }
  },
  computed:{
    calif : function(){
      var value = 0.0
      for (var i in this.data){
        if(i == 'PUNTAJE TOTAL' || i == 'Cobertura económica' || i == 'Valores comerciales de las coberturas'){
          continue
        }
        if(!isNaN(parseFloat(this.data[i]))){
          value += parseFloat(this.data[i])
        }
      }
      var cover = this.cover
      switch(cover){
        case cover < 109:
          value += 1
          break
        case cover < 125:
          value += 2
          break
        case cover < 149:
          value += 3
          break
        case cover < 199:
          value += 4
          break
        case cover < 249:
          value += 5
          break
        case cover < 299:
          value += 6
          break
        case cover >= 300:
          value += 6
          break
        default:
          value += 1
          break
      }
      value = value * 70.0 / 21.0
      value = value.toFixed(1)
      this.data['Cobertura económica'] = cover
      this.data['Valores comerciales de las coberturas'] = this.cobertura
      this.data['PUNTAJE TOTAL'] = value
      return value
    },
    cover : function(){
      var val = 0.0
      if(this.monto){
        val = (this.garantias / this.monto).toFixed(2)
      }
      
      return val
    },
    garantias : function(){
      var val = 0.0
      for(var i in this.cobertura){
        if(this.cobertura[i]){
          val += parseFloat(this.cobertura[i]) 
        }
      }
      return val
    },
  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.calif + 1
      this.$score['6C COLATERAL O GARANTÍAS'] = this.data
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      sessionStorage.removeItem('loaded')
      this.$router.push('7c')
    }.bind(this))
    window.scroll(0,0)
    this.$score = JSON.parse(sessionStorage.getItem('score'))
    if(this.$score['6C COLATERAL O GARANTÍAS']) this.data = this.$score['6C COLATERAL O GARANTÍAS']
  
    if(this.data){
      if (this.data['Valores comerciales de las coberturas']){
        this.cobertura = this.data['Valores comerciales de las coberturas']
      }
    }
    this.monto = this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Monto solicitado']
  }
    
}
</script>
